// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Guide_wrapper__EteoT","title":"Guide_title__H8qAC","description":"Guide_description__SFImc","inner":"Guide_inner__6FJ_3"};